import script from "./EmailCard.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailCard.vue?vue&type=script&setup=true&lang=js"

import "./EmailCard.vue?vue&type=style&index=0&id=2c9e8862&scoped=true&lang=css"

import exportComponent from "../../../venturestar-data-emails-sentistar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c9e8862"]])

export default __exports__